<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { cn } from '#ui-kit/lib/utils'

const props = defineProps<{
  class?: HTMLAttributes['class']
}>()
</script>

<template>
  <th
    data-slot="table-head"
    :class="
      cn('text-left align-middle text-2xs font-display font-normal text-secondary whitespace-nowrap', props.class)
    "
  >
    <slot />
  </th>
</template>
